export default "__VITE_ASSET__DbVEHPn2__"